import { Api, createApi, createUri } from './utils';

export enum CutStateUrl {
    Claims = 'claims',
    InvoiceDates = 'invoices/dates',
    InvoiceJobs = 'invoices/jobs',
}

const BASE_URL = createUri(Api.CutState, '/cutstate/V1');

export const cutStateApi = createApi<CutStateUrl>(BASE_URL);

export const uploadClaims = cutStateApi<{ key: string; csv: string }, unknown>(CutStateUrl.Claims, 'POST');
